export default __webpack_public_path__ + "assets/images/fad90a2406d863169fc8d0b43ca86649.png";